export enum LoadEventsEnum {
  participants,
  organizations
}